<template>
  <div>
    <i-select
    v-model="selectValue"
    :multiple="multiple"
    @on-change="onChange">
      <i-option v-for="item in selects" :value="String(item.id)" :key="item.id">{{ item.name }}</i-option>
    </i-select>
  </div>
</template>
<script>
import Select from '../iview/components/select'
import Option from '../iview/components/option'
export default {
  data () {
    return {
      selectValue: this.formatValue(this.value)
    }
  },
  components: {
    iSelect: Select,
    iOption: Option
  },
  props: {
    selects: {
      type: Array,
      default: () => {
        return []
      }
    },
    tkey: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      default: function () {
        if (this.multiple) {
          return []
        } else {
          return ''
        }
      }
    }
  },
  methods: {
    onChange () {
      this.$emit('input', { key: this.tkey, value: this.selectValue })
      this.$emit('blur')
    },
    formatValue (value) {
      if (Array.isArray(value)) {
        return value.map(item => String(item))
      } else {
        return String(value)
      }
    }
  },
  watch: {
    'multiple': function (n) {
      // console.log(n)
    },
    'value': function (newVal) {
      this.selectValue = this.formatValue(newVal)
    }
  }
}
</script>
<style lang="sass">
</style>
